import { startLoggingAllocations } from '@ck';
import { registerIcons } from '@ui';
import { appInfoString, enableMapSet, enablePatches } from '@utils';
import '@utils/setOperations';
import { mount } from 'svelte';
import App from './App.svelte';

console.log(appInfoString());

registerIcons();
startLoggingAllocations();
enableMapSet();
enablePatches();

const appElement = document.getElementById('app');
if (!appElement) {
  throw new Error('Element with id "app" not found');
}
const app = mount(App, {
  target: appElement
});

export default app;
